// Register the PWA service worker.
// We only register in production (and on https/localhost) — CRA dev server
// already plays nicely without one and aggressive caching during development
// gets confusing.

export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  if (window.location.hostname === "localhost") {
    // skip in local dev to avoid stale caches during iteration
    return;
  }
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        // Listen for updates
        reg.onupdatefound = () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.onstatechange = () => {
            if (installing.state === "installed" && navigator.serviceWorker.controller) {
              // New version available; reload once to pick it up
              installing.postMessage("SKIP_WAITING");
            }
          };
        };
      })
      .catch(() => {});
  });
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    // when a new SW takes over, reload to apply
    if (window.__aviary_reloading) return;
    window.__aviary_reloading = true;
    window.location.reload();
  });
}
